/** Counts for the administration landing screen. */
export default function AdminOverview({ data }) {
  if (!data) return null;
  return (
    <>
      <div className="adm-stats">
        {[
          { n: data.districts,    l: 'Districts' },
          { n: data.schools,      l: 'Schools' },
          { n: data.active_users, l: 'Active accounts' },
          { n: data.patches,      l: 'Patches' },
        ].map(s => (
          <div key={s.l} className="adm-stat">
            <div className="adm-stat-n">{s.n}</div>
            <div className="adm-stat-l">{s.l}</div>
          </div>
        ))}
      </div>

      {(data.never_signed_in > 0 || data.inactive_users > 0) && (
        <div className="adm-note">
          {data.never_signed_in > 0 && (
            <div><strong>{data.never_signed_in}</strong> active accounts have never signed in.</div>
          )}
          {data.inactive_users > 0 && (
            <div><strong>{data.inactive_users}</strong> accounts are deactivated.</div>
          )}
        </div>
      )}

      <div className="adm-card">
        <div className="adm-card-title">Accounts by role</div>
        {data.by_role.map(r => (
          <div key={r.code} className="adm-row">
            <span>{r.name}</span>
            <span className="adm-row-n">{r.count}</span>
          </div>
        ))}
      </div>
    </>
  );
}
